import { Button, Flex, Heading, Text, uiFactory } from "@/ui";
import { t } from "@/utils";
import NavigationBar from "@/components/NavigationBar";
import AppImage from "@/components/AppImage";
import { WizardProps } from "../Wizard";

const EnhancedSpan = uiFactory("span");

export default function AddCamera({ next, wizard }: WizardProps) {
  return (
    <Flex grow={1} direction="column" alignItems="center" minH={0}>
      <NavigationBar onClose={wizard.close} props={{ my: "1rem" }} />
      <Flex grow={1} shrink={1} overflow="hidden">
        <AppImage name="onboarding1.svg" />
      </Flex>
      <Flex direction="column" alignItems="center">
        <Heading as="h4" mt="24">
          {t("pairing.grabSecondDevice", { color: <EnhancedSpan color="error" /> })}
        </Heading>
        <Text mt="12" align="center">
          {t("pairing.weWillGuideYou")}
        </Text>
      </Flex>
      <Button mt="72" bg="primary" color="on-primary" minW="18.5rem" onClick={() => next()}>
        {t("startPairing")}
      </Button>
    </Flex>
  );
}
